<div class="h-[calc(100vh-68px)] flex justify-center items-center">
  <app-user-register-form></app-user-register-form>
</div>
